module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-ellipse-handy-money-d59606e01f868bbd8b88483f5b5f8a20.svg";